export default __webpack_public_path__ + "static/preview-0c96bee8fa955e58b7980738f5f63acb.jpg";